/**
 * API service for the RCC Buffers page
 */
import {
    GetBuffersDetailsDataInput,
    GetBuffersDetailsDataOutput,
    GetBuffersPageDataInput,
    GetBuffersPageDataOutput,
} from './model';
import { API_GATEWAY_PROCESS_NAME } from '../../../utils/constants';
import { apiRequest } from '../../../services/apiMiddleware';
import { store } from '../../../store';
import { selectStationCode } from '../../../store/slices/shiftPlanSlice';
import {
    logOperationalMetric,
    MetricType,
    RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB,
    GET_BUFFERS_PAGE_DATA_API,
    GET_BUFFERS_DETAILS_DATA_API,
} from '../../../utils/metric-utils';

/** Fetch the Buffers page: one card per buffer plus the summary tiles. */
export const getBuffersPageData = async (
    request: GetBuffersPageDataInput
): Promise<GetBuffersPageDataOutput> => {
    const startTime = Date.now();
    const stationCode = selectStationCode(store.getState()) || '';
    const requestPayload = {
        resourcePath: '/getBuffersPageData',
        httpMethod: 'post',
        processName: API_GATEWAY_PROCESS_NAME,
        requestBody: request,
    };
    try {
        const response = await apiRequest(requestPayload);
        logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB, GET_BUFFERS_PAGE_DATA_API, MetricType.SUCCESS);
        return response.data;
    } catch (error: any) {
        logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB, GET_BUFFERS_PAGE_DATA_API, MetricType.FAILED, error);
        throw error;
    }
};

/**
 * Fetch one buffer's drill-down: without `parentContainerId` the header, dwell buckets, trend
 * and top-level containers; with it, one page of that container's children.
 */
export const getBuffersDetailsData = async (
    request: GetBuffersDetailsDataInput
): Promise<GetBuffersDetailsDataOutput> => {
    const startTime = Date.now();
    const stationCode = selectStationCode(store.getState()) || '';
    const requestPayload = {
        resourcePath: '/getBuffersDetailsData',
        httpMethod: 'post',
        processName: API_GATEWAY_PROCESS_NAME,
        requestBody: request,
    };
    try {
        const response = await apiRequest(requestPayload);
        logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB, GET_BUFFERS_DETAILS_DATA_API, MetricType.SUCCESS);
        return response.data;
    } catch (error: any) {
        logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB, GET_BUFFERS_DETAILS_DATA_API, MetricType.FAILED, error);
        throw error;
    }
};
